import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../../store/theme.actions';
import RetirarControleExpiracaoProcesso from './RetirarControleExpiracaoProcesso';

function RetirarControleExpiracaoProcessoPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Retirar Controle Expiração Processo'));
  return (
    <RetirarControleExpiracaoProcesso />
  );
}

export default withTokenInterceptor(RetirarControleExpiracaoProcessoPage);
